import { Col, Image, Row, Spin } from "antd";
import Big from "big.js";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { CustomButton } from "../../../../components";
import { useShoppingCart } from "../../../../context/ShoppingCartContext";
import localStorageKey from "../../../../enumerations/localStorageKey";
import { usePostEmailSend } from "../../../../hooks/SignUp/signup.hooks";
import { moneyFormat } from "../../../../plugins/numberFormat";
import Link from "./icons/Link";
import Ok from "./icons/Ok";
import Phone from "./icons/Phone";
import Wifi from "./icons/Wifi";

import { ExclamationCircleFilled } from "@ant-design/icons";
import { useLogin } from "../../../../context/LoginContext";
import { CURRENCY } from "../../../../enumerations/currencyEnum";
import {
  useGetProductItemDays,
  useGetProductItemMethods,
} from "../../../../hooks/HomeProduct/homeproduct.hooks";
import { pushGtag } from "../../../../plugins/gtagFunction";
import Counter from "./components/Counter";
import OptionRadio from "./components/OptionRadio";
import Type from "./icons/Type";
import styles from "./styles.module.scss";

const ProductDetailPage = () => {
  const location = useLocation();
  const _state = location?.state;
  // const { uuid } = require("uuidv4");
  const [searchParams, setSearchParams] = useSearchParams();
  const { isLogin, checkIfVerified } = useLogin();
  const { mutate: resendCode } = usePostEmailSend();
  const [methodList, setMethodList] = useState<any[]>([]);
  const [productDetail, setProductDetail] = useState<any>({});
  const [selectedOption, setSelectedOption] = useState<any>({});
  const [selectedDay, setSelectedDay] = useState<any>({});
  const [isAddedToCart, setIsAddedToCart] = useState(false);
  const [hasUnlimit, setHasUnlimit] = useState(false);
  const [count, setCount] = useState(1);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { updateCart } = useShoppingCart();
  const { data: productMethod, isFetching } = useGetProductItemMethods(
    { product_id: _state?.id ? _state?.id : searchParams.get("id") },
    { enabled: !!searchParams.has("id") },
  );

  const { data: productDays, isFetching: dayIsFetching } =
    useGetProductItemDays(
      {
        product_id: _state?.id ? _state?.id : searchParams.get("id"),
        network_volume: selectedOption
          ? selectedOption?.network_volume
          : productMethod?.method[0],
        type: selectedOption?.type ? selectedOption?.type : "",
      },
      {},
    );

  const localLang = window.localStorage.getItem(localStorageKey.DEFAULT_LANG);

  const renderTelecom = (text: string) => {
    if (text?.includes("，")) {
      const texts = text.split("，");
      const format = texts.map((t: any, index: any) => {
        return <div>{t}</div>;
      });
      return format;
    } else {
      return text;
    }
  };

  const calculateAverage = (price?: number, days?: number) => {
    if (!price || !days) return "";
    const bigPrice = new Big(price);
    const bigDays = new Big(days);
    const average = bigPrice.div(bigDays).round().toString();
    return moneyFormat(average);
  };
  const addedToCartBtnStyle = {
    background: "rgba(0, 0, 0, 0.90)",
    borderColor: "transparent",
    color: "var(--green)",
  };

  const [timeoutInstance, setTimeoutInstance] = useState<any>(null);
  const onClickAddCart = () => {
    pushGtag({
      event: "product_add_to_cart",
      id: productDetail.id,
      name: productDetail.name,
      network_volume: selectedOption.network_volume,
      type: selectedOption.type,
      days: selectedDay.days,
      price: selectedDay.sell_price,
      count,
    });

    updateCart(selectedDay?.id, count);
    setIsAddedToCart(true);
    const timeout = setTimeout(() => {
      setIsAddedToCart(false);
    }, 1500);
    setTimeoutInstance(timeout);
  };

  useEffect(() => {
    return () => {
      if (timeoutInstance) {
        clearTimeout(timeoutInstance);
        setTimeoutInstance(null);
      }
    };
  }, []);

  useEffect(() => {
    if (productMethod) {
      const networkIds = productMethod.method.map((i: any) => {
        if (i.network_volume === -1) {
          setHasUnlimit(true);
        }
        return { ...i, id: uuidv4() };
      });
      setMethodList(networkIds);
      setProductDetail(productMethod?.info);
      setSelectedOption(networkIds[networkIds.length <= 1 ? 0 : 1]);
    }
  }, [productMethod]);

  useEffect(() => {
    if (productDays) {
      setSelectedDay(
        productDays[productDays.length <= 3 ? productDays.length - 1 : 3],
      );
    }
  }, [productDays]);

  useEffect(() => {
    setCount(1);
  }, [_state?.id]);

  return (
    <div>
      <Spin spinning={isFetching}>
        <div className={styles.productDetailPage}>
          <div className={styles.topArea}>
            <div className={styles.headerBox}>
              <div className={styles.titleBox}>
                <Image
                  src={productDetail?.img}
                  className={styles.countryIcon}
                  preview={false}
                />
                <div className={styles.title}>
                  {productDetail && productDetail["name"]}
                </div>
              </div>
              <div className={styles.textContainer}>
                <div className={styles.subInfo}>
                  <div className={styles.icon}>
                    <Phone />
                  </div>
                  <span className={styles.label}>{t("normal.telecom")}</span>
                  <span>{renderTelecom(productDetail?.telecom)}</span>
                </div>

                <div className={styles.subInfo}>
                  <div className={styles.icon}>
                    <Link />
                  </div>
                  <span className={styles.label}>
                    {t("normal.hotspot.share")}
                  </span>
                  <span
                    style={{
                      color: productDetail?.hotspot
                        ? "var(--green)"
                        : "var(--pink)",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    {productDetail?.hotspot ? (
                      <>
                        <Ok />
                        {t("normal.ok")}
                      </>
                    ) : (
                      <> {t("normal.not.ok")}</>
                    )}
                  </span>
                </div>

                <div className={styles.subInfo}>
                  <div className={styles.icon}>
                    <Wifi />
                  </div>
                  <span className={styles.label}>
                    {t("normal.cover.range")}
                  </span>
                  <span>{productDetail && productDetail["include_area"]}</span>
                </div>

                <div className={styles.productType}>
                  <div className={styles.iconArea}>
                    <Type />
                    <div className={styles.typeTxt}>
                      {t("normal.productType")}
                    </div>
                  </div>

                  <ul>
                    <li>{t("product.volume.type")}</li>
                    <li>{t("product.day.type")}</li>
                    {hasUnlimit ? <li>{t("product.unlimit.type")}</li> : ""}
                  </ul>
                </div>
              </div>
            </div>
            <div className={styles.contentBox}>
              {selectedDay && (
                <div className={styles.price}>
                  {`${CURRENCY.TW} ${moneyFormat(selectedDay?.sell_price)}`}
                  <span className={styles.average}>
                    {t("product.averagePrice.per.day", {
                      average: calculateAverage(
                        selectedDay?.sell_price,
                        selectedDay?.days,
                      ),
                    })}
                  </span>
                </div>
              )}
              <div className={styles.plan}>{t("product.plan")}</div>
              <div className={styles.optionContainer}>
                <Row
                  gutter={[
                    { xs: 16, sm: 16, md: 16 },
                    { xs: 16, sm: 16, md: 16 },
                  ]}
                >
                  {methodList?.map((item) => (
                    <Col
                      className="gutter-row"
                      lg={{ span: 6 }}
                      md={{ span: 6 }}
                      sm={{ span: 6 }}
                      xs={{ span: 6 }}
                      key={item.id}
                    >
                      <OptionRadio
                        optionData={item}
                        isActive={selectedOption?.id === item.id}
                        isMethod={true}
                        onItemClick={() => setSelectedOption(item)}
                      />
                    </Col>
                  ))}
                </Row>
              </div>
              <div className={styles.plan}>{t("product.days")}</div>
              <Spin spinning={dayIsFetching}>
                <div className={styles.optionContainer}>
                  <Row
                    gutter={[
                      { xs: 16, sm: 16, md: 16 },
                      { xs: 16, sm: 16, md: 16 },
                    ]}
                  >
                    {productDays?.map((item: any) => (
                      <Col
                        className="gutter-row"
                        lg={{ span: 6 }}
                        md={{ span: 6 }}
                        sm={{ span: 6 }}
                        xs={{ span: 6 }}
                        key={item.id}
                      >
                        <OptionRadio
                          optionData={item}
                          isActive={selectedDay?.id === item.id}
                          isMethod={false}
                          onItemClick={() => setSelectedDay(item)}
                        />
                      </Col>
                    ))}
                  </Row>
                </div>
              </Spin>
              <div className={styles.counterContainer}>
                <div className={styles.count}>{t("product.count")}</div>
                <Counter count={count} setCount={setCount} />
              </div>
              <div className={styles.btnBox}>
                <CustomButton
                  block
                  onClick={onClickAddCart}
                  disabled={isAddedToCart}
                  style={isAddedToCart ? addedToCartBtnStyle : {}}
                >
                  {isAddedToCart ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        // height: "14px",
                        gap: "10px",
                      }}
                    >
                      <Ok size={14} />
                      {t("normal.cart.added")}
                    </span>
                  ) : (
                    t("normal.addinto.cart")
                  )}
                </CustomButton>
                <CustomButton
                  block
                  type="primary"
                  danger
                  onClick={() => {
                    pushGtag({
                      event: "product_checkout",
                      id: productDetail.id,
                      name: productDetail.name,
                      network_volume: selectedOption.network_volume,
                      type: selectedOption.type,
                      days: selectedDay.days,
                      price: selectedDay.sell_price,
                      count,
                    });

                    const cart: any = window.localStorage.getItem(
                      localStorageKey.CART,
                    );
                    if (cart) {
                      const currentCart: any[] = JSON.parse(cart);
                      const target = currentCart.findIndex(
                        (item: any) => item.id === selectedDay?.id,
                      );
                      if (target < 0) updateCart(selectedDay?.id, count);
                    } else {
                      updateCart(selectedDay?.id, count);
                    }

                    if (isLogin) {
                      if (!checkIfVerified()) {
                        resendCode();
                        navigate("/verify");
                      } else {
                        navigate("/cart");
                      }
                    } else {
                      navigate("/signin");
                    }
                  }}
                >
                  {t("normal.buy.directly")}
                </CustomButton>
              </div>
            </div>
          </div>

          <div className={styles.bottomArea}>
            <div className={styles.attention}>
              <ExclamationCircleFilled />
              {t("normal.attention.info")}{" "}
            </div>
            <div
              className={styles.attentionTxt}
              dangerouslySetInnerHTML={{
                __html: productDetail && productDetail["info"],
              }}
            />
            <div className={styles.attentionImg}>
              <Image
                src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/${localLang}/reminder2.png`}
                fallback={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/reminder2.png`}
                alt="attention2"
                preview={false}
              />
            </div>
            <div className={styles.attentionImg}>
              <Image
                src={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/${localLang}/reminder.png`}
                fallback={`/images/brands/${process.env.REACT_APP_PROD_NAME_DEV}/reminder.png`}
                alt="attention"
                preview={false}
              />
            </div>
          </div>
        </div>
      </Spin>
    </div>
  );
};

export default ProductDetailPage;
